const credit = {
  // 信用分列表
  creditIndex: `/userApi/v1/Credit/index`,
  // 信用分说明
  creditDesc: `/userApi/v1/Credit/credit_desc`,
  // 用户信用分明细
  creditLog: `/userApi/v1/Credit/credit_log`
};

export default credit;
